import { useEffect, useCallback } from "react";
import { refreshTokenEventEmitter } from "../../api/sessionEvents";
import { logout } from "../../api/api_methods";

export default function SessionExpiryDialog() {
  const handleLoginAgain = useCallback(async () => {
    try {
      await logout();
      localStorage.removeItem("user");
      sessionStorage.clear();
    } catch (e) {}

    window.location.replace("/login");
  }, []);

  useEffect(() => {
    // Treat the show popup event as a direct trigger to logout and redirect
    refreshTokenEventEmitter.addEventListener(
      "show-refresh-token-popup",
      handleLoginAgain,
    );
    return () => {
      refreshTokenEventEmitter.removeEventListener(
        "show-refresh-token-popup",
        handleLoginAgain,
      );
    };
  }, [handleLoginAgain]);

  // Headless component; doesn't render any visible UI.
  return null;
}
